import Splide from '@splidejs/splide';

export default class SplideAutoMount extends HTMLDivElement {
    connectedCallback() {
        if (this.carousel) {
            return;
        }

        this.mountCarousel();
    }

    mountCarousel() {
        this.querySelectorAll(':scope > .splide__pagination, :scope > .splide__arrows')
            .forEach((el) => el.remove());

        this.carousel = new Splide(this,
            {
                lazyload: 'nearby',
            });

        this.carousel.mount();
    }
}
